import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import koCommon from './locales/ko/common.json';
import koAuth from './locales/ko/auth.json';
import koNotification from './locales/ko/notification.json';
import koError from './locales/ko/error.json';
import koBilling from './locales/ko/billing.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enNotification from './locales/en/notification.json';
import enError from './locales/en/error.json';
import enBilling from './locales/en/billing.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: {
        common: koCommon,
        auth: koAuth,
        notification: koNotification,
        error: koError,
        billing: koBilling,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        notification: enNotification,
        error: enError,
        billing: enBilling,
      },
    },
    fallbackLng: 'ko',
    supportedLngs: ['ko', 'en'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'notification', 'error', 'billing'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
